import uploadFile from '../api/uploadFileModel'
import getModels from '../api/getModels'

export default (eventType: string, fileName: string, sheetIndex: number, date?: string) => (dispatch, getState) => {
    const uid = getState().sheet.uid
    dispatch({ type: 'SHEET_UPLOADING_MODEL', importingMessage: null })

    uploadFile(eventType, uid, fileName, sheetIndex, date)
        .then(r => {
            const reader = r.body.getReader()
            reader.read().then(function getText({ done, value }) {
                if (done) {
                    dispatch({ type: 'SHEET_IMPORTED_MODEL' })
                    return
                }

                const text = new TextDecoder('utf-8').decode(value)
                console.log(text)
                if (text.startsWith('Error - ')) {
                    dispatch({ type: 'SHEET_IMPORT_MODEL_ERROR', errorMessage: text.slice(8) })
                    return
                }                
                dispatch({ type: 'SHEET_UPLOADING_MODEL', importingMessage: text })
                return reader.read().then(getText)
            })
        })
        .catch(err => {            
            err.response.json().then(({ error,...props }) => {
                dispatch({ type: 'UPLOAD_ERROR', message: error, statusCode: err.response.status })
            })
        })
}
